import { getOrder } from "@gaiaherbs/Services/OrderServiceExtension";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getOrder(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({
                type: "Data/Orders/FailedToLoadOrder",
                orderNumber: props.parameter.orderNumber,
                status: 404,
            });
            return false;
        }
        throw error;
    }
});
